<template>
  <div class="arrow-container">
    <img src="/img/icons/flipCoinPlayerPointer.png" alt="You" class="bouncing-arrow" />
    <div class="label">
      {{ $t('flipCoinYou') }}
      <span class="whiteShadow">{{ $t('flipCoinYou') }}</span>
      <span class="textStrokeElement">{{ $t('flipCoinYou') }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.arrow-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: -130px;
  z-index: 5;
}

.bouncing-arrow {
  animation: bounce 1s infinite;
  height: 59px;
}

.label {
  margin-top: 5px;
  font-weight: 900;
  font-size: 30px;
  background: linear-gradient(to bottom, #f7a306 0%, #9d3d09 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  text-transform: uppercase;

  .whiteShadow {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    font-size: 30px;
    color: #fff;
    top: 2px;
    left: 0;
    -webkit-text-fill-color: #fff;
    z-index: -1;
    isolation: isolate;
    text-shadow: 0px 2px 5px rgba(255, 255, 255, 1);
  }

  .textStrokeElement {
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 30px;
    color: #fff;
    top: 0;
    left: 0;
    -webkit-text-stroke: 2px #874618;
    z-index: -1;
    isolation: isolate;
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
